// '719D57AA';

import paper from '../assets/images/resources/paper.png';
import coal from '../assets/images/resources/coal.png';
import metal from '../assets/images/resources/metal.png';
import ammo from '../assets/images/resources/ammo.png';
import scrap from '../assets/images/resources/scraps.png';
import basicManual from '../assets/images/basic_manual.png';
import tacticsGuide from '../assets/images/tactics_guide.png';
import commander_xp_2 from '../assets/images/commander_xp_2.png';
import commander_xp_3 from '../assets/images/commander_xp_3.png';
import commander_xp_4 from '../assets/images/commander_xp_4.png';
import commander_crate from '../assets/images/resources/scraps.png';
import CI_SPECIAL_OFFERS from '../assets/images/category_icons/ci_special_offers.png';
import CI_DAILY_OFFERS from '../assets/images/category_icons/ci_daily_offers.png';
import CI_GEMS from '../assets/images/category_icons/ci_gems.png';
import CI_CRATES from '../assets/images/category_icons/ci_crates.png';
import CI_RESOURCES from '../assets/images/category_icons/ci_resources.png';
import CI_EVENT_PASS from '../assets/images/category_icons/ci_event_pass.png';
import CI_WEB_SHOP_EXCLUSIVE_OFFERS from '../assets/images/category_icons/ci_exclusive_offers.png';
import CI_COMMANDER_OFFERS from '../assets/images/category_icons/ci_commander.png';
import CI_SPECIAL_EVENTS from '../assets/images/category_icons/ci_special_events.png';

import christmasEventPassImg from '../assets/images/events/christmas-battle-pass.png';
import FortuneEventTokens from '../components/FortuneEventTokens/FortuneEventTokens';

// Import the centralized offers configuration
import {
    OFFER_TYPES as OFFER_TYPES_CONFIG,
    OFFER_TYPE_TO_NAME as OFFER_TYPE_TO_NAME_CONFIG,
    OFFER_TYPE_TO_CONFIG_NAME as OFFER_TYPE_TO_CONFIG_NAME_CONFIG,
    OFFER_NAME_TO_CONFIG_TYPE as OFFER_NAME_TO_CONFIG_TYPE_CONFIG,
    OFFER_TYPE_TO_CONFIG_ICON as OFFER_TYPE_TO_CONFIG_ICON_CONFIG,
    generateInitialCategories,
} from './offersConfig';

export const MOBILE_VIEW_BREAKPOINT = 1024;

export const SHOP_PATHNAME = '/shop';

export const LOGIN_PATHNAME = '/';
export const MILESTONES = '/milestones';

export const API = {
    url: 'https://b17-dev-3.azurewebsites.net/api/',
};

// add env constants
export let ENV = 'test';
const hostname = window.location.hostname;
if (hostname.includes('localhost')) {
    ENV = 'test';
} else if (hostname.includes('dev')) {
    ENV = 'test';
} else {
    ENV = 'live';
}

if (ENV === 'test') {
    API.url = 'https://b17-dev-3.azurewebsites.net/api/';
    // API.url = 'https://b17rc.azurewebsites.net/api/';
}
if (ENV === 'release') {
    API.url = 'https://b17rc.azurewebsites.net/api/';
}
if (ENV === 'live') {
    API.url = 'https://b17api.azurewebsites.net/api/';
}

export const ERRORS_MAP = {
    0: 'WENT_WRONG',
    1: 'ANDROID_PLAYER',
    2: 'PLAYER_NOT_FOUND',
    3: 'BANNED_USER',
    4: 'NOT_ALLOWED',
    5: 'MAINTENANCE',
};

export const ERROR_MAINTENANCE = 5;

export const EVENT_TYPES = {
    1: 'Halloween',
    2: 'Christmas',
    3: 'Easter',
    4: 'Valentines',
};

export const EVENTS_IMAGES = {
    1: null, //halloween
    2: christmasEventPassImg,
    3: null, // easter
    4: null, // valentines
};

// Export offer-related constants from centralized configuration
// These are now generated automatically from offersConfig.js
// (Flares [27] and the Special Events group [999] are registered there.)
export const OFFER_TYPES = OFFER_TYPES_CONFIG;
export const OFFER_TYPE_TO_NAME = OFFER_TYPE_TO_NAME_CONFIG;
export const OFFER_TYPE_TO_CONFIG_NAME = OFFER_TYPE_TO_CONFIG_NAME_CONFIG;
export const OFFER_NAME_TO_CONFIG_TYPE = OFFER_NAME_TO_CONFIG_TYPE_CONFIG;
export const OFFER_TYPE_TO_CONFIG_ICON = OFFER_TYPE_TO_CONFIG_ICON_CONFIG;

// Mascot variants used by the Flares offer (drives dynamic background/token art)
export const MASCOT_TYPES = {
    None: 0,
    Bear: 1,    // Wojtek
    Dog: 2,     // Judy
    Elephant: 3 // LinWang
};


// Reward kind, as sent in the `Type` field of a Gifts entry.
// The value below is the one observed in the commander crate promo; the rest of
// the enum is not documented yet, so confirm with the backend before adding to it.
export const GIFT_REWARD_TYPES = {
    commanderIntel: 1,
};

// Rarity index as sent by the backend (crate contents and Gifts)
export const RARITY_TO_CONFIG_KEY = {
    0: 'common',
    1: 'uncommon',
    2: 'rare',
    3: 'heroic',
};

export const RESOURCES_TYPES = {
    paper: 1,
    coal: 2,
    metal: 3,
    ammo: 4,
    scrap: 5,
};

export const RESOURCES_TYPES_TO_NAME = {
    1: 'Paper',
    2: 'Coal',
    3: 'Metal',
    4: 'Ammo',
    5: 'Scrap',
};

export const RESOURCES_IMAGES = {
    paper: paper,
    coal: coal,
    metal: metal,
    ammo: ammo,
    scrap: scrap,
};

export const COMMANDER_OFFERS_IMAGES = {
    crates: commander_crate,
    experience: {
        2: commander_xp_2,
        3: commander_xp_3,
        4: commander_xp_4,
    }
}

export const COMMANDER_OFFERS_NAMES = {
    experience: {
        2: 'Tactics Guide',
        3: 'Strategy Treatise',
        4: 'War Compendium',
    }
}

export const COMMANDER_RESOURCES_IMAGES = {
    basicManual: basicManual,
    tacticsGuide: tacticsGuide,
}

// Generate initial offer categories from centralized config
// This replaces the hardcoded OFFERS_CATEGORIES
export const OFFERS_CATEGORIES = generateInitialCategories();


export const SUPPORT_MAIL = 'siegeww2-support@imperialsupport.org';

let websiteUrl = '';
if (ENV === 'test') {
    websiteUrl = 'http://siege-vhosts-130-42.imperiax.info:1331/';
}
if (ENV === 'live') {
    websiteUrl = 'https://www.siegeworldwarii.com/';
}

export const WEBSITE_URL = websiteUrl;
export const WEBSITE_URL_NEWS = `${WEBSITE_URL}news`;
export const WEBSITE_URL_SUPPORT = `${WEBSITE_URL}#support`;
export const WEBSITE_URL_FAQ = `${WEBSITE_URL}faq`;
export const WEBSITE_URL_TERMS = `${WEBSITE_URL}terms-of-use`;
export const WEBSITE_URL_PRIVACY = `${WEBSITE_URL}privacy-policy`;
export const WEBSITE_URL_GALLERY = `${WEBSITE_URL}#gallery`;
export const WEBSITE_URL_COMMUNITY = `${WEBSITE_URL}#community`;
export const WEBSITE_URL_TERMS_OF_USE = `${WEBSITE_URL}terms-of-use`;
export const WEBSITE_URL_PRIVACY_POLICY = `${WEBSITE_URL}privacy-policy`;
export const WEBSITE_URL_HAVE_QUESTIONS = `${WEBSITE_URL}faq/official-web-shop-questions`;

export const DEFAULT_MENUS = [
    { name: 'shop', url: '/shop', isShop: true, isHighlighted: false },
    { name: 'milestones', url: '/milestones', isShop: true, isHighlighted: false, isSpecial: true },
    { name: 'news', url: WEBSITE_URL_NEWS, isShop: false, isHighlighted: false },
    { name: 'gallery', url: WEBSITE_URL_GALLERY, isShop: false, isHighlighted: false },
    { name: 'community', url: WEBSITE_URL_COMMUNITY, isShop: false, isHighlighted: false },
    { name: 'faq', url: WEBSITE_URL_FAQ, isShop: false, isHighlighted: false },
    { name: 'support', url: WEBSITE_URL_SUPPORT, isShop: false, isHighlighted: false },
];

export const TOASTS_TYPES = {
    success: 1,
    fail: 2
}